import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/state/store";
import axios from "axios";
import Swal from "sweetalert2";
import router from "@/router/index.js";

Vue.use(VueRouter);

export default {
    namespaced: true,
    state: {
        isLoggedIn: false,
        selectedInvitation: {
            jobRoles: []
        },
        selectedSubmission: {}
    },

    mutations: {
        setSelectedInvitationMutation(state, item) {
            state.selectedInvitation = item;
        },
        setSelectedSubmission(state, data) {
            state.selectedSubmission = data
        }
    },

    actions: {

        addUpdateSubmissionAction: async (_, submissionToBeUpdatedRequestBody) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.user.token;
            try {
                const { data, status } = await axios.post("/submission/addEditSubmission", submissionToBeUpdatedRequestBody);
                if (status === 200) {
                    store.state.submission.selectedSubmissionId = data.id;
                }
                return data;
            } catch (error) {
                Swal.fire({
                    icon: "info",
                    title: "Προσοχή!",
                    text: (error.response && error.response.data && error.response.data.message) || "Αποτυχία υποβολής",
                    timer: 2500,
                    timerProgressBar: true,
                    showConfirmButton: false
                });
                throw error;
            }
        },

        getSubmissionByUserIdAndInvitationIdAction: async ({ commit }, querySubmission) => {
                axios.defaults.headers.common["Authorization"] = "Bearer " + store.state.user.token;
                const res = await axios.get("/submission/user/" + querySubmission.userId + "/invitation/" + querySubmission.invitationId)
                .then(({ data, status }) => {
                    if (status === 200) {
                        commit("setSelectedSubmission", data);
                    }
                    return data;
                })
                .catch((error) => {
                    console.log(error);
                    return null;
                });
                return res;
        },

        uploadFileAction: async (_, submission) => {
                const formData = new FormData();
                formData.append("file", submission.file);
                formData.append("filename", submission.filename);
                formData.append("subid", submission.subid);
                formData.append("userName", submission.userName);
                formData.append("invName", submission.invName);
                // Return the promise so the caller can await + catch errors
                // (e.g. 413 Payload Too Large from Apache/nginx/Spring).
                const { status } = await axios.post("/submission/uploadFile", formData, {
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
                if (status !== 200) {
                    throw new Error("Upload failed with status " + status);
                }
                return submission.filename;
        },

    },

    getters: {
        getSelectedInvitationJobRoles(state) {
            return state.selectedInvitation.jobRoles;
        },
        getSelectedSubmission(state) {
            return state.selectedSubmission;
        },
    }
}
